import React from 'react';

import { AccentBadge } from './accent-badge';
import { IBadgeProps } from './types';

export const LoginRequiredBadge: React.FC<IBadgeProps> = ({ formatMessage }) => (
  <AccentBadge data-testid="login-required-badge">
    {formatMessage({ id: 'signUpToRedeem' })}
  </AccentBadge>
);
